var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.carbonPrefix}--breadcrumb-item`},[_c('a',{class:`${_vm.carbonPrefix}--link`},[_vm._v(" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }